var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Space, Input, Card } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import SelectModal from './SelectModal'; // 导入 SelectModal
import api from '@/api';
const DeclaredDifficultyEditorModal = ({ visible, onOk, onCancel, initialSelectedData, currentRecord, projectTech, }) => {
    const [selectedButton, setSelectedButton] = useState('P2'); // 默认选中 P2
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isSelectModalVisible, setIsSelectModalVisible] = useState(false); // 控制 SelectModal 的显示
    const [currentSelectedDItem, setCurrentSelectedDItem] = useState(null); // 存储 SelectModal 的选中项
    const [totalData, setTotalData] = useState(null); // 存储总数据
    const [detailInfo, setDetailInfo] = useState(null); // 存储详情数据
    const [dOptions, setDOptions] = useState([]); // 配置项
    const [filteredButtonOptions, setFilteredButtonOptions] = useState([]); // 过滤后的按钮选项
    const [buttonOptions, setButtonOptions] = useState(['C', 'S', 'D', 'P1', 'P2', 'R', 'T', 'B1', 'B2']); //默认显示全部配置项
    //如果是P1,P2触发子弹框数据筛选更新
    const [positions, setPositions] = useState(null);
    // ['construction', 'support', 'direction', 'positions','positions','rotation_base','rotation','bonus','bonus']
    const buttonOptionsParams = {
        'C': 'construction',
        'S': 'support',
        'D': 'direction',
        'P1': 'positions',
        'P2': 'positions',
        'R': 'rotation_base',
        'T': 'rotation',
        'B1': 'bonus',
        'B2': 'bonus',
    };
    const displayedCodeValue = React.useMemo(() => {
        var _a;
        const baseScorePart = ((_a = currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.baseScore) === null || _a === void 0 ? void 0 : _a.slice(-1)) || '';
        const parts = [];
        const processedIndices = new Set();
        for (let i = 0; i < buttonOptions.length; i++) {
            if (processedIndices.has(i)) {
                continue;
            }
            const currentButtonCode = buttonOptions[i];
            const currentItem = totalData === null || totalData === void 0 ? void 0 : totalData[currentButtonCode];
            const currentCodeValue = currentItem === null || currentItem === void 0 ? void 0 : currentItem.codeValue;
            if (currentCodeValue) {
                let segment = currentCodeValue;
                const nextButtonCode = buttonOptions[i + 1];
                const nextItem = totalData === null || totalData === void 0 ? void 0 : totalData[nextButtonCode];
                const nextCodeValue = nextItem === null || nextItem === void 0 ? void 0 : nextItem.codeValue;
                // Check for P1/P2 or B1/B2 combinations
                const isPCombination = (currentButtonCode === 'P1' && nextButtonCode === 'P2') || (currentButtonCode === 'P2' && nextButtonCode === 'P1');
                const isBCombination = (currentButtonCode === 'B1' && nextButtonCode === 'B2') || (currentButtonCode === 'B2' && nextButtonCode === 'B1');
                if (nextCodeValue && (isPCombination || isBCombination)) {
                    segment += '/' + nextCodeValue;
                    processedIndices.add(i + 1); // Mark the next item as processed
                }
                parts.push(segment);
            }
        }
        let joinedString = parts.join('-');
        if (baseScorePart && joinedString) {
            return baseScorePart + '-' + joinedString;
        }
        else if (baseScorePart) {
            return baseScorePart;
        }
        else {
            return joinedString;
        }
    }, [totalData, currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.baseScore, buttonOptions]);
    const getDetailInfo = (row) => __awaiter(void 0, void 0, void 0, function* () {
        // 调用接口获取详细信息
        const res = yield api.CoachCardApi.getScoresByCodes({
            base_mark: row.baseScore || '',
            declared_difficulty_code: row.declaredDifficulty || '',
            bonus_code: row.bonus || '',
            part: row.content || '',
            eventphase_type1: (projectTech === null || projectTech === void 0 ? void 0 : projectTech.substring(2)) || ''
        });
        if (res.data.code == 200) {
            setDetailInfo(res.data.data);
        }
    });
    //根据不同基准分,获取不同的配置项数据
    const getSelectComponent = (row) => __awaiter(void 0, void 0, void 0, function* () {
        // 调用接口获取详细信息
        const res = yield api.CoachCardApi.getAcroComponents({
            base_mark: row.baseScore || '',
        });
        if (res.data.code == 200) {
            const data = res.data.data || {};
            const options = Object.keys(data);
            setDOptions(options);
        }
    });
    useEffect(() => {
        if (initialSelectedData) {
            // 根据 initialSelectedData 设置表格选中项和按钮选中项
            // 这里需要根据实际业务逻辑来确定如何从 initialSelectedData 映射到按钮和表格选中
            setSelectedRowKeys([initialSelectedData.code]);
            setSelectedRow(initialSelectedData);
        }
        else {
            setSelectedRowKeys([]);
            setSelectedRow(null);
        }
        if (visible) {
            getDetailInfo(currentRecord);
            getSelectComponent(currentRecord);
        }
    }, [initialSelectedData, visible, currentRecord]);
    //展示不同配置项
    useEffect(() => {
        const newFilteredButtonOptions = buttonOptions.filter(buttonCode => {
            const paramKey = buttonOptionsParams[buttonCode];
            return dOptions.includes(paramKey);
        });
        //过滤后的配置显示
        setFilteredButtonOptions(newFilteredButtonOptions);
    }, [dOptions, buttonOptions]);
    useEffect(() => {
        // 当弹框可见且 filteredButtonOptions 准备就绪，并且没有 declaredDifficulty 需要回显时，才初始化 totalData
        if (visible && filteredButtonOptions.length > 0 && !(currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.declaredDifficulty)) {
            setTotalData(filteredButtonOptions.reduce((acc, code) => {
                acc[code] = {
                    code: code,
                    dd: '',
                    description: '',
                    codeValue: '',
                };
                return acc;
            }, {}));
            setCurrentSelectedDItem(null);
        }
        // 当弹框关闭时，重置所有相关状态
        if (!visible) {
            setTotalData(null);
            setCurrentSelectedDItem(null);
        }
    }, [visible, filteredButtonOptions, currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.declaredDifficulty]);
    useEffect(() => {
        if (visible && currentRecord && currentRecord.declaredDifficulty && filteredButtonOptions.length > 0) { // 确保 filteredButtonOptions 已有值
            parseAcroCode();
        }
    }, [visible, currentRecord, filteredButtonOptions]); // 添加 filteredButtonOptions 作为依赖项
    //调用接口,回显数据
    const parseAcroCode = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield api.CoachCardApi.parseAcroCode({
            code: currentRecord.declaredDifficulty,
            base_mark: currentRecord.baseScore
        });
        if (res.data.code === 200) {
            const formattedComponents = {};
            filteredButtonOptions.forEach(code => {
                var _a, _b;
                const component = (_a = res.data.data.components) === null || _a === void 0 ? void 0 : _a[code];
                formattedComponents[code] = {
                    code: code,
                    dd: ((_b = component === null || component === void 0 ? void 0 : component.dd) === null || _b === void 0 ? void 0 : _b.toString()) || '',
                    description: (component === null || component === void 0 ? void 0 : component.description) || '',
                    codeValue: (component === null || component === void 0 ? void 0 : component.code) || '',
                };
            });
            setTotalData(formattedComponents);
        }
    });
    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'DD',
            dataIndex: 'dd',
            key: 'dd',
            render: (text, record) => (<Input value={text} onChange={(e) => {
                    // 处理 DD 列的输入变化
                    const newTotalData = Object.assign({}, totalData);
                    if (newTotalData[record.code]) {
                        newTotalData[record.code] = Object.assign(Object.assign({}, newTotalData[record.code]), { dd: e.target.value });
                    }
                    setTotalData(newTotalData);
                }} readOnly={true}/>),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => (<Input value={text} onChange={(e) => {
                    // 处理 Description 列的输入变化
                    const newTotalData = Object.assign({}, totalData);
                    if (newTotalData[record.code]) {
                        newTotalData[record.code] = Object.assign(Object.assign({}, newTotalData[record.code]), { description: e.target.value });
                    }
                    setTotalData(newTotalData);
                }} readOnly={true}/>),
        },
    ];
    const handleOk = () => {
        onOk({
            ShowdifficultyValue: displayedCodeValue,
            code: '',
            dd: '',
            description: '',
        });
    };
    const handleCancel = () => {
        onCancel();
    };
    const showSelectModal = (option) => {
        //如果是p1,p2，整理下接口数据,返回数据筛选出p1或者p2的数据
        setPositions(option);
        setIsSelectModalVisible(true);
    };
    const handleSelectModalOk = (selectedItem) => {
        setCurrentSelectedDItem(selectedItem);
        setIsSelectModalVisible(false);
        if (selectedItem) {
            setTotalData((prevTotalData) => {
                const newTotalData = Object.assign({}, prevTotalData);
                if (selectedItem.code === 'clear') {
                    if (newTotalData[selectedButton]) {
                        newTotalData[selectedButton] = {
                            code: selectedButton,
                            dd: '',
                            description: '',
                            codeValue: '', // 清空 codeValue
                        };
                    }
                }
                else {
                    newTotalData[selectedButton] = {
                        code: selectedButton,
                        dd: selectedItem.dd,
                        description: selectedItem.description,
                        codeValue: selectedItem.code,
                    };
                }
                return newTotalData;
            });
        }
    };
    const handleSelectModalCancel = () => {
        setIsSelectModalVisible(false);
    };
    return (<Modal title="Declared Difficulty Editor" open={visible} onOk={handleOk} onCancel={handleCancel} width="80%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span style={{ fontSize: 20, marginBottom: 4 }}>BM</span>
          <Button type="primary" style={{ fontSize: 20, fontWeight: 'bold', height: 40, padding: '0 15px', minWidth: 80 }}>
            {parseFloat((detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.base_mark_score) || '0.0000').toFixed(4) || '0.0000'}
          </Button>
        </div>
        <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
          {filteredButtonOptions.map((option, index) => {
            var _a, _b;
            return (<div key={option} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ marginBottom: 4 }}>{option}</span>
              <Button style={{
                    backgroundColor: selectedButton === option ? '#4CAF50' : '#d4edda',
                    color: selectedButton === option ? '#fff' : undefined,
                    fontSize: 20,
                    height: 40,
                    padding: '0 15px',
                    minWidth: 50,
                }} onClick={() => {
                    setSelectedButton(option);
                    showSelectModal(option);
                }}>
                {((_a = totalData === null || totalData === void 0 ? void 0 : totalData[option]) === null || _a === void 0 ? void 0 : _a.codeValue) ? (_b = totalData === null || totalData === void 0 ? void 0 : totalData[option]) === null || _b === void 0 ? void 0 : _b.codeValue : '\u00A0'}
              </Button>
            </div>);
        })}
        </Space>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span style={{ fontSize: 20, marginBottom: 4 }}>DD</span>
          <Button type="primary" style={{ fontSize: 20, fontWeight: 'bold', height: 40, padding: '0 15px', minWidth: 80 }}>
            {
        //列表数据的值
        ((Object.values(totalData || {})
            .reduce((sum, item) => sum + (parseFloat(item.dd) || 0), 0)) + parseFloat((detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.base_mark_score) || '0.0000'))
            .toFixed(4)
            || '0.0000'}
          </Button>
        </div>
      </div>
      <Table rowKey="code" // 添加这一行
     columns={columns} dataSource={Object.values(totalData || {})} pagination={false} bordered size="small" onRow={(record) => {
            return {
                onClick: () => {
                    setSelectedRowKeys([record.code]);
                    setSelectedRow(record);
                },
            };
        }}/>
      {/*  总计算显示*/}
      <Card>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <span style={{ fontSize: 24, fontWeight: 'bold' }}>{displayedCodeValue}
          </span>
        </div>
      </Card>
      <SelectModal visible={isSelectModalVisible} onOk={handleSelectModalOk} onCancel={handleSelectModalCancel} initialSelectedItem={currentSelectedDItem} positions={positions} baseMark={currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.baseScore} selectedButton={buttonOptionsParams[selectedButton]}/>
    </Modal>);
};
export default DeclaredDifficultyEditorModal;
